import React from 'react';
import { Link } from 'react-router-dom';
import Paragraph from "@scentregroup/ui/components/paragraph";
import classNames from 'classnames';
import UtilityBox from '../utility-box';
import { slugify } from '../../helpers';
import { isTrustedUrl } from '../../helpers/url';
import { DISCOVER } from '../../constants';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FEATURED_LINK = 'FeaturedLink';
const categoryLimit = 5;

const entriesToLimit = entries => (entries || []).slice(0, categoryLimit);

const getTheUrlByTypeName = (centre, link) => {
  if (link.__typename === FEATURED_LINK) {
    try {
      return isTrustedUrl(link.url);
    } catch (e) {
      return '';
    }
  } else {
    return "/".concat(centre.slug, "/browse-stores/").concat(slugify(link.title));
  }
};

const getUtilityPanelHeading = (centre, heading) => (heading && heading.length) > 0 ? heading : "".concat(DISCOVER, " ").concat(centre.title);

const CentreUtilityBox = ({
  heading,
  entries,
  centre,
  angleOrigin,
  color,
  origin
}) => {
  const utilityBoxComponent = /*#__PURE__*/_jsxs("div", {
    className: style.evolved,
    children: [/*#__PURE__*/_jsx("div", {
      className: classNames(style.angleAtTop, style[color], style[angleOrigin], style[origin])
    }), /*#__PURE__*/_jsx("div", {
      className: classNames(style.wrapper, style[origin]),
      children: /*#__PURE__*/_jsxs(UtilityBox, {
        className: style.CentreUtilityBox,
        children: [/*#__PURE__*/_jsx(Link, {
          className: style.utilityDiscover,
          to: "/".concat(centre.slug, "/browse-stores"),
          "data-test-id": "discover-center",
          children: getUtilityPanelHeading(centre, heading)
        }), /*#__PURE__*/_jsx("section", {
          className: style.links,
          children: entriesToLimit(entries).map(link => /*#__PURE__*/_jsx("a", {
            className: style.utilityLink,
            href: getTheUrlByTypeName(centre, link),
            children: /*#__PURE__*/_jsx(Paragraph, {
              className: style.utilityLinkText,
              children: link.title
            })
          }, link.title))
        })]
      })
    })]
  });

  return entries && entries.length > 0 ? utilityBoxComponent : null;
};

export default CentreUtilityBox;